function headerMenu(){

};


$(document).ready(function() {

    //header-tab-bar
    $(document).on("click", ".header-tab-bar .mdc-tab", function() {
        if (!$(this).hasClass('active-tab-btn')) {
            $(".active .header-tab-bar .mdc-tab").removeClass('active-tab-btn');
            $(this).addClass('active-tab-btn');
            var get_id = "#" + $(this).attr("data-id");
            $(".active .tab-content.active").fadeOut(function() {
                $(".active .tab-content").removeClass('active')
                $(get_id).addClass('active').fadeIn(function() {                    
                });
            });
        }
        
    });
    
     //header dropdown
    $(document).on("click", ".header-menu-wrap .selected-tab-text", function() {
        if ($(window).innerWidth() < 992) {
            $(this).toggleClass("open-menu");
            $(".active .header-tab-bar").slideToggle(function() {
                $(".active .header-tab-bar button").click(function() {
                    var text = $(this).find(".mdc-tab__text-label").html();
                    $(".active .selected-tab-text").html(text);
                    $(".active .header-tab-bar").hide();
                    $(".active .selected-tab-text").removeClass("open-menu");
                });
            });
        } else {
        }
    });
    
    $(document).on("click", ".invites-menu-wrap .selected-tab-text-invite", function() {
        if ($(window).innerWidth() < 992) {
            $(this).toggleClass("open-menu");
            $(".active .header-tab-bar-invite").slideToggle(function() {
                $(".active .header-tab-bar-invite button").click(function() {
                    var text = $(this).find(".mdc-tab__text-label").html();
                    $(".active .selected-tab-text-invite").html(text);
                    $(".active .header-tab-bar-invite").hide();
                    $(".active .selected-tab-text-invite").removeClass("open-menu");
                });
            });
        } else {
        }
    })

    $(document).on("click", ".video-review-menu-wrap .selected-tab-text-video-review", function() {
        if ($(window).innerWidth() < 992) {
            $(this).toggleClass("open-menu");
            $(".active .header-tab-bar-video-review").slideToggle(function() {
                $(".active .header-tab-bar-video-review button").click(function() {
                    var text = $(this).find(".mdc-tab__text-label").html();
                    $(".active .selected-tab-text-video-review").html(text);
                    $(".active .header-tab-bar-video-review").hide();
                    $(".active .selected-tab-text-video-review").removeClass("open-menu");
                });
            });
        } else {
        }
    })
    
});

$(window).resize(function(){
    
})

$(window).resize(function(){
    if ($(window).width() > 991) {
        $(".header-tab-bar").css("display", " ");
    }
    else{
		$(".headerreplace .header-tab-bar").hide();
    }

});
